import React, { Component } from 'react';
import { connect } from 'react-redux';

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "./style.css";

class TemplateDefault extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="template-default">
                <Header />
                {
                    !!!this.props.window_close ? "" : (
                        <button onClick={e => window.close()}  className="btn btn-link" style={{color:"#36404a"}}><span className="glyphicon glyphicon-arrow-left"></span> Voltar</button>
                    )
                }
                
                <div className="box-top">
                    <div className={`box-generic ${ this.props.custom_class }`} >
                      { this.props.children }
 
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

// "state" is set in reducers/index.js
function mapStateToProps(state) {
    return {
        //user: state.user
    };
}

export default connect(mapStateToProps)(TemplateDefault);